import { InjectionToken, Provider, Type } from '@angular/core';

import { STANDARD_ITEM_RESULT_VIEW_COMPONENTS, WIRE_CUT_ITEM_RESULT_VIEW_COMPONENTS } from '../../types';
import { ProvideItemResultComponentConfig } from './ProvideItemResultComponentConfig';
import { ProductTypes } from 'products-data';

export function provideItemResultComponent(config: ProvideItemResultComponentConfig): Provider[] {
  let provide: InjectionToken<Type<unknown>[]>;
  switch (config.type) {
    case ProductTypes.Wire:
      provide = WIRE_CUT_ITEM_RESULT_VIEW_COMPONENTS;
      break;
    case ProductTypes.Standard:
    default:
      provide = STANDARD_ITEM_RESULT_VIEW_COMPONENTS;
      break;
  }
  return [
    {
      provide,
      useValue: config.component,
      multi: true,
    },
  ] as Provider[];
}
